import CategoryCardContainer from './CategoryCardContainer'

export default CategoryCardContainer
